export default {
  account: {
    attributes: {
      name: 'Nombre',
      type: 'Tipo',
    },
    header: {
      title: 'Servicio de Email',
      subtitle: '¡Configura un Servicio de E-mail que uses o todos los que uses!',
      searchAccount: 'Buscar una Cuenta',
    },
    list: {
      insert_date: 'Adicionado en',
      actions: 'Acciones',
      deprecated: 'Obsoleto',
    },
    editModal: {
      header: 'Añade una cuenta de servicio de e-mail',
      helpBlock: 'Completa el formulario de aquí abajo por favor.',
      select: 'Selecciona',
      save: 'Guardar',
      activeCampaign: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiUrl: 'URL',
        apiUrlPlaceholder: 'API URL',
      },
      aweber: {
        help: 'Para finalizar la integración con Aweber, haz clic en botón Guardar.',
      },
      convertKit: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiSecret: 'Secret',
        apiSecretPlaceholder: 'API Secret',
      },
      eGoi: {
        apiKey: 'Tu API Key',
      },
      getResponse: {
        apiKey: 'GetResponse API Key',
        apiKeyPlaceholder: 'API Key',
      },
      mailChimp: {
        apiKey: 'Mailchimp API Key',
        apiKeyPlaceholder: 'API Key',
      },
      rdStation: {
        apiKey: 'Tu Token',
        apiKeyPlaceholder: 'Token',
        help: 'Para finalizar la integración con el RD Station, haga clic en el botón Guardar que está a continuación.',
      },
    },
    types: {
      getResponse: 'GetResponse',
      activeCampaign: 'Active Campaign',
      aweber: 'Aweber',
      convertKit: 'ConvertKit',
      eGoi: 'E-Goi',
      mailChimp: 'MailChimp',
      rdStation: 'RD Station',
    },
    actions: {
      new: 'NUEVA CUENTA',
      edit: 'Editar',
      delete: 'Eliminar',
    },
    notify: {
      success: {
        delete: 'Servicio de e-mail removido con éxito.',
        create: 'Servicio de e-mail guardado con éxito.',
        update: 'Servicio de e-mail actualizado con éxito.',
      },
      error: {
        aweber: 'Se produjo un error en la conexión con aweber',
        rdstation: 'Se produjo un error en la conexión con el RDStation',
      },
    },
  },
  modal: {
    delete: {
      title: 'EXCLUIR',
      message: '¿Tienes certeza que deseas excluir este servicio de email? ¡Esta acción es irreversible!',
      confirm: 'Sí, Excluir',
      cancel: 'Cancelar',
    },
  },
  notifications: {
    noNotifications: 'No hay notificaciones nuevas.',
    unableLoad: 'No pudimos cargar notificaciones en este momento.',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/es.js